// https://stripe.dev/react-stripe-elements/#ideal


import React, { Component } from 'react';
import {
  IdealBankElement,
  injectStripe,
  StripeProvider,
  Elements,
} from 'react-stripe-elements';
import './CardDemo.scss';
// You can customize your Elements to give it the look and feel of your site.
const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        letterSpacing: '0.025em',
        padding: '5px 14px',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#c23d4b',
      }
    }
  };
};

class _IdealBankForm extends Component {
  state = {
    bankSelected: false,
    currentStatus : false
  };

  handleSubmit = (ev) => {
    ev.preventDefault();
    this.setState({currentStatus : true})
    if (this.props.stripe) {
      this.props.stripe.createSource({
        type: 'ideal',
        amount: this.props.amount,
        currency: 'eur',
        mandate: {
          notification_method: 'email'},
        // You can specify a custom statement descriptor.
        statement_descriptor: this.props.statementDescriptor,
        owner: {
          name: ev.target.name.value,
        },
        redirect: {
          return_url: this.props.returnUrl,
        },
      })
        .then(this.props.handleResult);
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  };
  handleChange = (event) => {
    if(event.value && event.value !== "") {
      this.setState({bankSelected : true})
    }
  };

  render() {
    const buttonStyle = this.props.agreementStatus && this.state.bankSelected && !this.state.currentStatus ? {backgroundColor : (window.settings.brand && window.settings.brand.cta && window.settings.brand.cta.primary && window.settings.brand.cta.primary.backgroundColor) || "#6772e5"} : {backgroundColor : (window.settings.brand && window.settings.brand.cta && window.settings.brand.cta.primary && window.settings.brand.cta.primary.backgroundColor) || "#6772e5",opacity:0.6,pointerEvents:"none"}
    return (
      <div className="elements-preview">
        <section>
        <form onSubmit={this.handleSubmit.bind(this)} id="payment-form" style={{display:'block', "marginTop": '0em'}}>
          <div class="input_wrapper">
            <label htmlFor="name">
              {this.props.fields.iDealNameLabel || "Name"}
          <input name="name" type="text" placeholder="Jane Doe" required />
            </label>
          </div>
          <div class="input_wrapper">
            <label>
              {this.props.fields.iDealBankLabel || "iDEAL Bank"}
              <div id="ideal-bank-element">
                <IdealBankElement {...createOptions()} onChange={this.handleChange.bind(this)} />
              </div>
            </label>
            <div className="submit-wrapper">
            <button className="button" style={buttonStyle}>{this.state.currentStatus ? (this.props.fields.paymentProcessing || "Processing...") : (this.props.fields.iDealSubmitCTA || "Submit Payment")}</button>
            </div>
          </div>
        </form>
        </section>

      </div>
    );
  }
}

const IdealForm = injectStripe(_IdealBankForm);

export default class IdealDemo extends Component {
  render() {
    return (
      <StripeProvider apiKey={this.props.stripePublicKey}>
        <Elements>
          <IdealForm handleResult={this.props.handleResult}
            returnUrl={this.props.returnUrl}
            amount={this.props.amount}
            agreementStatus={this.props.agreementStatus}
            statementDescriptor={this.props.statementDescriptor}
            currentStatus={this.props.currentStatus}
            fields={this.props.fields}
           />
        </Elements>
      </StripeProvider>
    );
  }
}
